import styled from "styled-components";
import React from "react";
import { TextInputWTitleDisable } from "../inputs/TextInputWTitleDisable";
import { InputTitle } from "../inputs/InputTitle";
import { CheckboxProfile } from "../inputs/CheckboxProfile";
import { SelectDateInputDisabled } from "../inputs/SelectDateInputDisabled";
import { TextInputWTitleDisableBig } from "../inputs/TextInputWTitleDisableBig";

const StyleCss = styled.div`
  grid-column: 1 / 13;
  width: auto !important;
  .loading-ep {
    display: flex;
    justify-content: center;
    margin: 100px auto 0;
  }
  .block {
    display: flex;
    flex-direction: row;
    .expand {
      flex-grow: 1;
    }
    &.first {
      background-color: #f3822555;
      .side-color {
        width: 50px;
        background-color: var(--primary-1);
      }
      .base-data {
        padding: 1.5rem 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .name {
          font-size: 2rem;
          font-weight: 700;
        }
        .normal {
          margin-left: 1px;
          font-weight: 500;
        }
      }
      .image {
        margin: 1rem calc(50px + 0.5rem) 1rem 0;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border: 1px solid var(--n-grey-11);
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    &.title {
      margin: 1.5rem 0 0.5rem calc(50px + 0.5rem);
      font-size: 1.5rem;
      font-weight: 600;
    }
    &.text {
      margin: 0 calc(50px + 0.5rem) 0.5rem;
      font-size: 1rem;
      font-weight: 400;
    }
    &.items{
      margin: 0 calc(50px + 0.5rem) 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .row {
        margin: 2rem 0;
      }
      .data {
        margin: 0 0;
        display: flex;
        justify-content: space-between;
        /* border-bottom: 1px solid lightgray; */
        padding: 0.6rem 0;
        :last-child{
          border-bottom: none;
        }
        .right {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          .top {
            font-size: 1.1rem;
          }
        }
      }
    }
  }
  .container {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 40px 40px 40px 20px;
    &.notop {
      padding: 0 40px 0 20px;
    }
    .rightelement,
    .leftelement {
      width: 48%;
    }
    .full-width {
      width: 100%;
      &.title {
        font-size: 1.3rem;
        font-weight: 600;
      }
    }
    .vertical-devider {
      width: 1px;
      border-left: 1px solid var(--n-grey-3);
    }
    .row {
      margin: 2rem 0;
      /* padding: 0 10px; */
      :first-child{
        margin: 0 0 2rem;
      }
      .textarea {
        height: 5rem !important;
        width: 50% !important;
      }
      .new-input {
        padding: 0 calc(1rem - 1px);
      }
      .image-file {
        width: calc(100% - calc(var(--border-radius)));
        padding: calc(var(--border-radius) / 2);
        border-radius: calc(var(--border-radius) / 2);
        border: 1px var(--n-grey-10) solid;
        background-color: var(--n-grey-11);
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        display: flex;
        gap: 0.6rem;
        .texts {
          gap: 0.5rem;
          width: calc(100% - calc(120px + 0.3rem));
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            font-size: 11px;
            font-weight: 600;
          }
          .desc {
            font-size: 11px;
            font-weight: 400;
            color: var(--n-grey-7);
          }
        }
        .image {
          background-color: var(--border-2);
          border-radius: calc(var(--border-radius) / 4);
          width: 120px;
          padding-top: 120px;
          position: relative;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
          }
        }
      }
      
    }
  }
`;


function ResumeDataShow(props) {
  let data = props.resume
  let udata = props.userdata
  return (
    <StyleCss>
      <div className="block first">
        <div className="side-color"></div>
        <div className="base-data">
          <div className="name">{data.Name}</div>
          <div className="normal">{data.Email} . {data.Mobile}</div>
          <div className="normal">Address: {data.Address}</div>
          <div className="normal">Birthday: {data.BirthYear}</div>
          <div className="normal">Maried: {data.Maried}</div>
          <div className="normal">Gender: {data.Gender}</div>
          {
            (data.Gender === "male") ? (
              <div className="normal">Military: {data.Military}</div>
            ) : ""
          }
        </div>
        <div className="expand"></div>
        <div className="image">
          <img src={data.image} alt={"resume image"}/>
        </div>
      </div>
      {/* <div className="container">
        <div className="full-width title">
          Personal Info
        </div>
      </div>
      <div className="container notop">
        <div className="rightelement">
          <div className="row">
            <TextInputWTitleDisable
              value={data.Name}
              title={'Name'}
            />
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Birthday</InputTitle>
              <SelectDateInputDisabled value={data.BirthYear} name={'birthday'} error={''} disabled={true}/>
            </div>
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.Email}
              title={'Email'}
            />
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.Mobile}
              title={'Mobile '}
            />
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.Address}
              title={'Address'}
            />
          </div>
        </div>
        <div className='vertical-devider'></div>
        <div className="leftelement">
          <div className="row">
            <div className='image-file'>
              
              <div className='image'>
                <img src={data.image} alt={"resume image"}/>
              </div>
              <div className='texts'>
                <div className='title'>
                    image
                </div>
                <div className='desc'>
                    For uploading image click the edit button
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <TextInputWTitleDisable
              value={data.Maried}
              title={'Maried Status'}
            />
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Gender</InputTitle>
              <CheckboxProfile value={data.Gender} name={'Gender'} disabled={true}/>
            </div>
          </div>
          {
            (data.Gender === "male") ? (
              <div className="row">
                <TextInputWTitleDisable
                  value={data.Military}
                  title={'Military'}
                />
              </div>
            ) : ""
          }
        </div>
      </div> */}
      <div className="block title">
        About Me
      </div>
      <div className="block text">
        {(data.Description) ? data.Description : "Not Filled"}
      </div>
      <div className="block title">
        Professional Skills
      </div>
      <div className="block text">
        {(data.DescriptionJob) ? data.DescriptionJob : "Not Filled"}
      </div>
      <div className="block title">
        Education Background
      </div>
      <div className="block items">
        {
          data.EduBack.map((val) => {
            return <Education data={val}/>
          })
        }
      </div>
      <div className="block title">
        Job Experience
      </div>
      <div className="block items">
        {
          data.JobBack.map((val) => {
            return <Jobs data={val}/>
          })
        }
      </div>
      <div className="block title">
      Languages
      </div>
      <div className="block items">
        {
          data.LanBack.map((val) => {
            return <Language data={val}/>
          })
        }
      </div>
    </StyleCss>
  );
}
export default ResumeDataShow;



function Jobs (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top">
          {data.JobTitle}
        </div>
        <div className="small">
          {data.companyName}
        </div>
      </div>
      <div className="left">
        <FormatDate InDate={data.InDate} OutDate={data.OutDate}/>
      </div>
    </div>
  )
}

function Education (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        <div className="top">
          {data.EduName} - {data.EduTitle}
        </div>
        <div className="small">
          {data.Where}
        </div>
      </div>
      <div className="left">
        <FormatDate InDate={data.InDate} OutDate={data.OutDate}/>
      </div>
    </div>
  )
}
function Language (props) {
  let data = props.data
  return (
    <div className="row data">
      <div className="right">
        {data.LanTitle}
      </div>
      <div className="left">
        {data.Level}
      </div>
    </div>
  )
}



function FormatDate(props) {
  let inDate = props.InDate.split("/");
  let outDate = props.OutDate.split("/");
  inDate.reverse()
  outDate.reverse()
  inDate = inDate.join('/')
  outDate = outDate.join('/')
  return (
    <>
      from {inDate} to {outDate}
    </>
  )
}